import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { useTranslation } from 'react-i18next';

const NotFound = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { user } = useAuth();

    if (!user) {
        return (
            <Box
                sx={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    height: '100vh',
                    width: '100vw',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'lightgray',
                    gap: '2rem',
                }}
            >
                <Typography variant="h6">{t('common.noContent')}</Typography>
                <Button variant="contained" onClick={() => navigate('/')}>
                    {t('common.backToLogin')}
                </Button>
            </Box>
        );
    }

    return (
        <Box
            style={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '2rem',
            }}
        >
            <Typography variant="h6">{t('common.noContent')}</Typography>
            <Button variant="contained" onClick={() => navigate('/')}>
                {t('common.backToHome')}
            </Button>
        </Box>
    );
};

export default NotFound;
